import { Component, OnInit, AfterViewInit, AfterContentInit, AfterContentChecked } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit{

  constructor(private navigation: NavigationService) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.navigation.scrollToElement();
    },5);
  }
}
